import { createAction, props } from '@ngrx/store';
import { IBillingTransactionsReferences } from 'src/app/my-bill/models/billing-transactions-references.model';

export const GET_BILLING_TRANSACTIONS_REFERENCES_REQUEST =
  'GET_BILLING_TRANSACTIONS_REFERENCES_REQUEST';
export const GET_BILLING_TRANSACTIONS_REFERENCES_SUCCESS =
  'GET_BILLING_TRANSACTIONS_REFERENCES_SUCCESS';
export const GET_BILLING_TRANSACTIONS_REFERENCES_FAILURE =
  'GET_BILLING_TRANSACTIONS_REFERENCES_FAILURE';

export const getBillingTransactionsReferencesRequest = createAction(
  GET_BILLING_TRANSACTIONS_REFERENCES_REQUEST,
  (billingAccountNumber: string) => ({
    billingAccountNumber,
  })
);

export const getBillingTransactionsReferencesSuccess = createAction(
  GET_BILLING_TRANSACTIONS_REFERENCES_SUCCESS,
  props<{
    billingAccountNumber: string;
    transactionsReferences: IBillingTransactionsReferences;
  }>()
);

export const getBillingTransactionsReferencesFailure = createAction(
  GET_BILLING_TRANSACTIONS_REFERENCES_FAILURE,
  props<{ billingAccountNumber: string }>()
);
